<template>
  <section class="all-cases-view" id="all-sendOuts-list">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row>
            <el-col :lg="7">
              <ul class="d-flex list-items-group-15 barcode-print">
                <li>
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="SendoutId / Patient Name"
                      v-model="search_string"
                      @input="getAutoCompleteOrders()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :lg="17">
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <li>
                  <div
                    class="form-element search-with-filter-input-without-icon"
                  >
                    <el-select
                      v-model="searchBy"
                      clearable
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      placeholder="Select Search"
                      @change="clearInputSearch"
                    >
                      <el-option
                        v-for="item in searchOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </div>
                </li>
                <li v-if="searchBy == 'Patient DOB'">
                  <div class="search-with-date-input">
                    <el-date-picker
                      format="MM-DD-YYYY"
                      v-model="date_of_birth"
                      :disabled-date="disabledDate"
                      @change="fetchAllSendOuts()"
                      placeholder="Select DOB"
                      :clearable="true"
                    ></el-date-picker>
                  </div>
                </li>
                <li v-else-if="searchBy == 'hospital'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="selectedHospital"
                      placeholder="Select Ordering Facility"
                      filterable
                      clearable
                      default-first-option
                      value-key="_id"
                      @change="onHospitalChange"
                      remote
                      @focus="onHospitalFocus"
                      :remote-method="remoteMethodFacility"
                      :loading="hospitalsLoading"
                    >
                      <el-option
                        v-for="hospital in hospitalsData.data"
                        :key="hospital"
                        :label="hospital.name"
                        :value="hospital"
                      ></el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'ordering_physician'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="physician"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      @change="handleCurrentChange(1)"
                      @focus="fetchAllPhysicians"
                      :loading="physiciansLoading"
                    >
                      <el-option
                        v-for="physician in physiciansData.data"
                        :key="physician"
                        :label="`${physician?.first_name || ''} ${physician?.last_name || ''}`.trim()"
                        :value="physician._id"
                      ></el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllSendOuts.data"
            height="calc(100vh - 200px)"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
            style="width: 100%"
            @sort-change="onChangeSort"
          >
            <el-table-column
              fixed="left"
              prop="sendout_id"
              label="SENDOUT"
              min-width="220"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession" style="display: flex;align-items: center;column-gap: 10px;">
                  <span id="accession-id" @click="onView(scope.row._id)">{{
                    scope.row.sendout_id
                  }}</span>
                  <div
                    v-if="scope.row.is_stat && !showStatCase()"
                    style="width: 41px;color: #1b2459"
                  >
                    STAT
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="left"
              prop="accession_id"
              label="ACCESSION ID"
              min-width="130"
              sortable="custom"
            >
              <template #default="scope">
                <template v-if="scope.row.case_id">
                  <div class="name-accession cursor">
                    <span
                      id="accession-id-blue"
                      @click="goToCaseView(scope.row.case_id)"
                      >{{ scope.row.accession_id }}</span
                    >
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              min-width="125"
              prop="case_types"
              sortable="custom"
              fixed="left"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}
                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                          >{{ caseType }}</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div v-else class="case-type">
                  <span class="case-data-type">{{
                    getCaseTypes(scope.row.case_types)[0]
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="patient_info.first_name"
              label="PATIENT NAME"
              width="160"
              sortable="custom"
              fixed="left"
            >
              <template v-slot="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  "
                  @click="
                    copyTitle(getPatientNameByInfo(scope.row.patient_info))
                  "
                >
                  <span class="text-center ordering_facility-value">{{
                    convertToUppercase(
                      getPatientNameByInfo(scope.row.patient_info)
                    )
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="Patient DOB"
              min-width="120"
              prop="date_of_birth"
            >
              <template #default="scope">
                <div style="cursor: default" v-if="scope.row.patient_info">
                  {{ formatDate(scope.row.patient_info.date_of_birth) }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="hospitals"
              label="ORDERING FACILITIES"
              min-width="215"
            >
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="scope.row.hospital ? scope.row.hospital.name : '--'"
                >
                  <span class="ordering_facility-value">{{
                    scope.row.hospital ? scope.row.hospital.name : "--"
                  }}</span>
                </el-button>
              </template>
            </el-table-column>
            
            <el-table-column label="Physician" min-width="120">
              <template #default="scope">
                <el-button
                  placement="top"
                  class="title-on-hover"
                  :title="
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.first_name + ' ' + scope.row.ordering_physician.last_name
                      : '--'
                  "
                >
                  <span class="ordering_physician-value">
                    {{
                      scope.row.ordering_physician
                        ? scope.row.ordering_physician.first_name + " " + scope.row.ordering_physician.last_name
                        : "--"
                    }}
                  </span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              label="CREATED ON"
              min-width="130"
              prop="created_at"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.created_at">
                  <div class="d-flex">
                    <div class="text-center date pr-5" style="cursor: default">
                      {{
                        momentWithTimezone(scope.row.created_at, "MM-DD-yyyy", scope.row.timezone)
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Received On"
              min-width="130"
              prop="received_date"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.received_date">
                  <div class="d-flex">
                    <div class="date pr-5" style="cursor: default">
                      {{
                        momentWithTimezone(
                          scope.row.received_date,
                          "MM-DD-yyyy",
                          scope.row.timezone
                        )
                      }}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              min-width="130"
              prop="status"
              sortable="custom"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <span
                    class="el-dropdown-link"
                    v-if="scope.row.status && scope.row.status == 'COMPLETE'"
                  >
                    <el-tag
                      style="cursor: default"
                      :type="getStatusType(scope.row.status)"
                      >FINALIZED</el-tag
                    >
                  </span>
                  <span class="el-dropdown-link" v-else>
                    <el-tag
                      style="cursor: default"
                      :type="getStatusType(scope.row.status)"
                    >
                      {{ scope.row.status.split("_").join(" ") }}
                    </el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              width="150"
              fixed="right"
            >
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li @click="onView(scope.row._id)">
                    <el-button class="view-button" title="View Sendout">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    v-if="
                      scope.row.status != 'ARCHIVED' &&
                      scope.row.status == 'COMPLETE'
                    "
                  >
                    <el-button
                      title="Test Reports"
                      class="reports-button"
                      @click="onViewReports(scope.row)"
                    >
                      <span class="afterTestReportsIcon">
                        <img
                          src="@/assets/images/icons/actions/afterViewIcon.svg"
                          alt="icon"
                          style="width: 18px"
                        />
                      </span>
                    </el-button>
                  </li>
                </ul>
              </template>
            </el-table-column>
          </el-table>
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[25, 50, 75, 100]"
              layout="prev, pager, next, jumper, sizes, total"
              :total="getAllSendOuts.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import caseConstants from "@/config/constants/caseConstants";
import FilterHelper from "@/mixins/FilterHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import exportExcelHelper from "@/mixins/exportExcelHelper";
import {
  sendOutSearchOptions,
} from "@/config/constants/searchConstants";
import caseDataHelper from "@/mixins/caseDataHelper";
export default {
  name: "hospital",
  props: {
    selectedStatuses: {
      default: [],
    },
  },
  mixins: [
    FilterHelper,
    UserPermissionsHelper,
    exportExcelHelper,
    caseDataHelper,
  ],
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      scrollPosition: null,
      searchOptions: sendOutSearchOptions,
      search_string: "",
      hospital: "",
      date_of_birth: "",
      physician: "",
      searchBy: "",
      caseType: "",
      page: 1,
      pageSize: 25,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      caseTypes: caseConstants.CASE_TYPES_DATA,
      loading: false,
      orderBy: "",
      orderType: "",
      searchCaseLoading: false,
      hospitalsData: { data: [] },
      physiciansData: {},
      physiciansLoading: false,
      hospitalsLoading: false,
      selectedHospital: null,
    };
  },
  computed: {
    checkNewReport() {
      return (caseData) => {
        if (caseData && caseData.test_reports && caseData.test_reports.length) {
          return true;
        } else {
          return false;
        }
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "TEST_RESULTS") {
          return "info";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else {
          return "";
        }
      };
    },
    ...mapGetters("sendOuts", [
      "getAllSendOuts",
    ]),
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
     ...mapGetters("auth", [
      "getUserPrimaryLabId",
    ]),
    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
  },
  mounted() {
    this.setQueryParamsData();
    this.fetchAllSendOuts();
  },
  methods: {
    onViewReports(report) {
      let markForPhysician = report?.test_reports.find(
        (e) => e.mark_for_physician
      );
      if (!markForPhysician) {
        console.warn("No physician report found");
        return;
      }
      let routerData = this.$router.resolve({
        name: "supplementaryReportView",
        params: {
          report_id: markForPhysician._id,
          case_id: report.case_id,
        },
      });
      this.fetchAllSendOuts();
      window.open(routerData.href, "_blank");
    },
    async updateScroll() {
      this.scrollPosition = window.scrollY;
    },
    goToCaseView(case_id) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: case_id },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    onView(caseId) {
      this.$router.push({
        name: "SendoutsInformation",
        params: { sendout_id: caseId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.date_of_birth ||
        this.caseType
      ) {
        this.hospital = "";
        this.selectedHospital = null;
        this.physician = "";
        this.date_of_birth = "";
        this.caseType = "";
        this.page = 1;
        this.fetchAllSendOuts(1);
      }
    },
    async fetchAllPhysicians() {
      try {
        this.physiciansLoading = true;
        await this.$store.dispatch("physicians/fetchAllPhysicians", {
          get_all: true,
        });
        this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
        this.physiciansLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async remoteMethodFacility(query) {
      if (query !== "") {
        await this.fetchAllHospitals(query);
      } else {
        this.hospitalsData.data = [];
      }
    },
    onHospitalFocus() {
      this.hospitalsData.data = [];
    },
    onHospitalChange(value) {
      this.hospital = value && value._id ? value._id : "";
      this.handleCurrentChange(1);
    },
    async fetchAllHospitals(hospital) {
      try {
        this.hospitalsLoading = true;
        let params = {
          limit: 25,
        };
        if (hospital) {
          params.search_string = hospital;
        } else {
          params.get_all = true;
        }
        await this.$store.dispatch("hospitals/fetchAllHospitals", params);
        this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
        this.hospitalsLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    setQueryParamsData() {
      this.page = this.$route.query.selectedPage
        ? parseInt(this.$route.query.selectedPage)
        : 1;
      this.pageSize = this.$route.query.selectedPageSize
        ? parseInt(this.$route.query.selectedPageSize)
        : 25;
      if (this.$route.query.selectedString) {
        this.search_string = this.$route.query.selectedString;
      }
      if (this.$route.query.selectedCase) {
        this.caseType = this.$route.query.selectedCase;
      }
      if (this.$route.query.selectedSearchBy) {
        this.searchBy = this.$route.query.selectedSearchBy;
      }
      if (this.$route.query.selectedPhysician) {
        this.fetchAllPhysicians();
        this.physician = this.$route.query.selectedPhysician;
      }
      if (this.$route.query.selectedHospital) {
        this.hospital = this.$route.query.selectedHospital;
        const restoredName = this.$route.query.selectedHospitalName || "";
        if (this.hospitalsData && Array.isArray(this.hospitalsData.data)) {
          const found = this.hospitalsData.data.find(
            (h) => h._id === this.hospital
          );
          this.selectedHospital =
            found ||
            (this.hospital ? { _id: this.hospital, name: restoredName } : null);
          if (!found && this.selectedHospital) {
            this.hospitalsData.data = [
              ...this.hospitalsData.data,
              this.selectedHospital,
            ];
          }
        } else {
          this.selectedHospital = this.hospital
            ? { _id: this.hospital, name: restoredName }
            : null;
        }
      }
      if (this.$route.query.selectedDateOfBirth) {
        this.date_of_birth = this.$route.query.selectedDateOfBirth;
      }
      if (this.$route.query.selectedOrderBy) {
        this.orderBy = this.$route.query.selectedOrderBy;
      }
      if (this.$route.query.selectedOrderType) {
        this.orderType = this.$route.query.selectedOrderType;
      }
    },
    getAutoCompleteOrders() {
      setTimeout(() => {
        this.page = 1;
        this.fetchAllSendOuts();
      }, 600);
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAllSendOuts();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.fetchAllSendOuts();
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "";
        this.orderType = "";
      }
      this.fetchAllSendOuts();
    },
    prepareParams() {
      let params = {
        page: this.page,
        limit: this.pageSize,
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (this.hospital) {
        params.hospital = this.hospital;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.physician) {
        params.ordering_physician = this.physician;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }
      if (this.selectedStatuses && this.selectedStatuses.length) {
        params.status = this.selectedStatuses[0];
      }
      return params;
    },
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedCase: params.case_type,
        selectedHospital: params.hospital,
        selectedHospitalName:
          (this.selectedHospital && this.selectedHospital.name) ||
          (this.hospitalsData && this.hospitalsData.data
            ? (
                this.hospitalsData.data.find(
                  (h) => h._id === params.hospital
                ) || {}
              ).name
            : undefined),
        selectedDateOfBirth: params.date_of_birth,
        selectedPhysician: params.ordering_physician,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
        selectedSearchBy: this.searchBy || undefined,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    async fetchAllSendOuts() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        if (this.getUserPrimaryLabId) {
          params.lab = this.getUserPrimaryLabId;
        }
        await this.$store.dispatch("sendOuts/getSendOuts", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin button-css {
  min-width: 100px;
  height: auto;
  min-height: 20px;
  padding: 6px 5px;
  color: #4bb543;
  font-size: 12px !important;
  font-weight: 500 !important;
  line-height: 1;
  letter-spacing: 0 !important;
  text-align: center;
  border: 0.6px solid #4bb543;
  border-radius: 4px !important;
  &:hover,
  &:active,
  &:focus {
    color: #4bb543;
    border: 0.6px solid #4bb543;
  }
}
.btn-success {
  @include button-css;
}
.btn-danger {
  @include button-css;
  color: #eb5757 !important;
  border: 0.6px solid #eb5757 !important;
  &:hover,
  &:active &:focus {
    color: #eb5757;
    border: 0.6px solid #eb5757;
  }
}

.btn-active {
  @include button-css;
  color: #5162fd !important;
  border: 0.6px solid #5162fd !important;
  &:hover,
  &:active &:focus {
    color: #5162fd;
    border: 0.6px solid #5162fd;
  }
}
.btn-processing {
  @include button-css;
  color: #f28b0c !important;
  border: 0.6px solid #f28b0c !important;
  &:hover,
  &:active,
  &:focus {
    color: #f28b0c;
    border: 0.6px solid #f28b0c;
  }
}
#all-sendOuts-list {
  .stickyNavbar {
    padding-bottom: 5px !important;
    .container-default {
      padding-top: 0;
      padding-bottom: 5px;
    }
  }
}
</style>
